import axios from 'axios';

const apiURL = process.env.REACT_APP_BASE_URL;

export function getGraphViewData(req){
    return axios.post(apiURL+"GraphView/GetGraphViewData",req);
}